import React from 'react'

import { Filters } from 'components'

import constants from 'constants/index'

const TreatmentFilters = ({ filter, matrixRisks = [], departments = [] }) => {
  const { STATUS_ITEMS } = constants.dataProcessTreatment

  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Processo" name="dataProcessName" />
      <select
        multipleselectinput="true"
        label="Departamento"
        name="departmentIds"
        optionvalues={departments || []}
      />
      <select textfieldinput="true" label="Risco" name="dataProcessRisk">
        <option value=""></option>
        {matrixRisks?.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        {STATUS_ITEMS.map((item) => (
          <option key={item.id} value={item.id}>
            {item.label}
          </option>
        ))}
      </select>
      <input datepickerinput="true" label="Prazo" name="deadlineDate" />
    </Filters>
  )
}

export default TreatmentFilters
